(ns com.theplantscape.conversions.ensemble
  (:require [com.theplantscape.conversions.core :as c])
)

(def units {:mm "millimeters" :cm "centimeters" :m "meters" :ft "foot" :s 0.001})
(def supported-unites (keys units))

(defn sqr [n] (c/sqr n))

(defn distance [xy1 xy2] (c/distance xy1 xy2))
(defn distance-unit [xy1 xy2 unit] (c/distance-unit xy1 xy2 unit))
(defn points->middle [xy1 xy2] (c/points->middle xy1 xy2))
(defn convert-units [value unit] (c/convert-units value unit))
